// extracted by mini-css-extract-plugin
module.exports = {"PostMenuTrigger":"pn_a bhj_i bhj_j bhj_q bhj_un bhj_wf bhj_en"};